var Config = {
    DEBUG: false,
    LIB_VERSION: '2.23.0'
};

export default Config;
